export default __webpack_public_path__ + "static/media/cymbal-bg.98f40611.jpg";